exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".workflows-list .cell-limited-max-width {\n  display: inline-block;\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n.workflows-list .cell-limited-max-width.name {\n  max-width: 350px;\n}\n", ""]);

// exports
